import script from "./Signup.vue?vue&type=script&setup=true&lang=ts"
export * from "./Signup.vue?vue&type=script&setup=true&lang=ts"

import "./Signup.vue?vue&type=style&index=0&id=f76092dc&lang=css"

const __exports__ = script;

export default __exports__